import { render } from "./monthdetail.vue?vue&type=template&id=65827c79"
import script from "./monthdetail.vue?vue&type=script&lang=js"
export * from "./monthdetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__